import { CalendarDateFormatter, DateFormatterParams } from 'angular-calendar';
import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomDateFormatter extends CalendarDateFormatter {
    // you can override any of the methods defined in the parent class

    public monthViewColumnHeader({ date, locale }: DateFormatterParams): string {
        return new DatePipe('pt-PT').transform(date, 'EEE', locale);
    }

    public monthViewTitle({ date, locale }: DateFormatterParams): string {
        return new DatePipe('pt-PT').transform(date, 'MMM y', locale);
    }

    public weekViewColumnHeader({ date, locale }: DateFormatterParams): string {
        return new DatePipe('pt-PT').transform(date, 'EEE', locale);
    }

    public dayViewHour({ date, locale }: DateFormatterParams): string {
        return new DatePipe('pt-PT').transform(date, 'HH:mm', locale);
    }
}
